






















import Vue from 'vue';
import { IEventListener, IIcons } from '@/common/interfaces/index.interface';
import { TDisplayMode } from '@/common/types/index.types';
import config from '../../../config';
import EventListenerHelper from '../../helpers/EventListenerHelper';
import CustomButton from '../layout/buttons/CustomButton.vue';

interface IProductsOverviewViewToggle {
  mountedWindowEventListeners: IEventListener[];
  showDisplayModeSelection: boolean;
}

export default Vue.extend({
  name: `ProductsOverviewViewToggle`,
  components: { CustomButton },
  data(): IProductsOverviewViewToggle {
    return {
      mountedWindowEventListeners: [],
      showDisplayModeSelection: true,
    };
  },
  props: {
    icons: {
      required: true,
      type: Object as () => IIcons,
    },
    mode: {
      required: true,
      type: String,
    },
  },
  created(): void {
    this.mountedWindowEventListeners = [
      { callback: this.handleWindowResize, name: `resize` },
    ];
  },
  mounted(): void {
    EventListenerHelper.setUpEventListeners(this.mountedWindowEventListeners, window);
    if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < config.breakpoints.gridToListView) {
      this.toggleDisplayModeSelection(false, `grid`);
    }
  },
  beforeDestroy(): void {
    EventListenerHelper.teardownEventListeners(this.mountedWindowEventListeners, window);
  },
  methods: {
    emitModeChange(mode: TDisplayMode): void {
      this.$emit(`update:display-mode-changed`, mode);
    },
    handleWindowResize(e: Event): void {
      if((e.target as EventTarget & { outerWidth: number }).outerWidth < config.breakpoints.gridToListView) {
        if(this.mode === `list`) {
          this.toggleDisplayModeSelection(false, `grid`);
        } else {
          this.showDisplayModeSelection = false;
        }
      } else {
        this.showDisplayModeSelection = true;
      }
    },
    toggleDisplayModeSelection(show: boolean, mode: TDisplayMode): void {
      this.showDisplayModeSelection = show;
      this.emitModeChange(mode);
    },
  },
});
